// extracted by mini-css-extract-plugin
export var wrapper = "footer-module--wrapper--3yPKy";
export var center = "footer-module--center--vEMPF";
export var footer = "footer-module--footer--3VpLX";
export var piktogram = "footer-module--piktogram--1hB4d";
export var backToTop = "footer-module--backToTop--3RHgv";